export default __webpack_public_path__ + "static/media/nodata.5927459c.svg";